export const extractNodeName = (full: string): string => {
  const idx = full.lastIndexOf("#N#");

  return idx >= 0 ? full.slice(idx + 3) : full;
};
